import { convertISOFormatToDate, convertISOFormatToOnlyDate } from './tools';
import { REPORT_STATUS } from './constants';

/**
 * 報告書のステータスコードを日本語のステータステキストに変換する
 *
 * @param {string} status - 報告書のステータスコード
 * @returns {string} 日本語でのステータステキスト
 */
export function getStatusText(status) {
  switch (status) {
    case REPORT_STATUS.CREATE:
      return '下書き';
    case REPORT_STATUS.PUBLISHED:
      return '共有';
    case REPORT_STATUS.COMPLETE:
      return '完了';
    default:
      return '不明なステータス';
  }
}

/**
 * グループ番号と報告書番号を受け取り、フォーマットされた報告書番号を生成する。
 *
 * @param {number} groupNo - 報告書に紐づくグループ番号(6桁以内)
 * @param {number} reportNo - 報告書番号(4桁以内)
 * @param {string} reportStatus - 報告書のステータス
 * @returns {string} フォーマットされた報告書番号
 */
export const createReportNo = (groupNo, reportNo, reportStatus) => {
  if (reportStatus === REPORT_STATUS.CREATE) {
    return '------ - ----';
  }

  const groupNoPadded = String(groupNo).padStart(6, '0');
  const reportNoPadded = String(reportNo).padStart(4, '0');

  return `${groupNoPadded}-${reportNoPadded}`;
};

/**
 * reduxで管理する報告書オブジェクト`state.report.reportDetail`を受け取り、表示用に変換された報告書情報を返す。
 *
 * @param {Object} report - reduxで管理する報告書オブジェクト`state.report.reportDetail`
 * @param {number} report.groupNo - 報告書のグループ番号。
 * @param {number} report.reportNo - 報告書の番号。
 * @param {string} report.name - 報告書の名前。
 * @param {string} report.status - 報告書のステータス。
 * @param {string} report.createdOperatorName - 報告書の作成者名。
 * @param {string} report.createdAt - 報告書の作成日。
 * @param {string} report.lastUpdatedOperatorName - 最終更新者名。
 * @param {string} report.updatedAt - 最終更新日時。
 * @returns {Object} 変換された報告書情報。
 */
export const transformReport = report => ({
  number: createReportNo(report.groupNo, report.reportNo, report.status),
  subject: report.name,
  status: getStatusText(report.status),
  author: report.createdOperatorName,
  creationDate: convertISOFormatToOnlyDate(report.createdAt),
  lastUpdatedBy: report.lastUpdatedOperatorName,
  lastUpdatedDate: convertISOFormatToDate(report.updatedAt),
});
